/*----------------------------------
- DEPENDANCES
----------------------------------*/

// Npm
import React from 'react';
import { useErrorBoundary } from 'preact/hooks';

// Core
import { Blog } from '@app';
import RouterComponent from '@client/services/router/components/router';
import { Button, Popover, Link, Input } from '@client/components';

// App
import { createRedirParams } from '@/client/pages/convert/upgrade/Plans';
import { buildSearchUrl, getCurrentFilters} from '@/common/libs/filters';
import Analytics from '@/client/services/metrics/Component';

// Resources
import './index.less';
import Logo from '@/client/assets/identity/logo-dark.png';
import LoaderComponent from './Loader';

/*----------------------------------
- TYPES
----------------------------------*/

/*----------------------------------
- LAYOUT
----------------------------------*/

// TODO: Route.layout()
// TODO: route.config.bodyClass
export const data = ({ api, app, context }) => ({
    navigation: api.get('/blog/navigation')
})

export default ({ data, user, api, Router, toast, modal, context, app, request, page }) => {

    /*----------------------------------
    - INIT
    ----------------------------------*/

    // Render bug report
    // TIDO: move to framework
    useErrorBoundary(e => {
        app.reportBug({
            before: 'Render page',
            stacktrace: e.stack
        }).then(() => {

            // Reload page
            if (__DEV__) {
                console.warn(`The app would be reloaded in production mode.`);
                toast.error(`Errur during page rendering: ${e.message}`);
                console.error(e);
            } else 
                toast.error(`An issue occurred while loading this page. Our dev team will solve it asap.`);
        })
    });

    const searchInput = React.useRef();

    const [openMenu, setOpenMenu] = React.useState<boolean>(false);
    context.setOpenMenu = setOpenMenu;

    // On page change, close menus
    React.useEffect(() => {
        return Router.on('page.changed', () => {
            setOpenMenu(false);
        });
    }, []);

    /*----------------------------------
    - ACTIONS
    ----------------------------------*/ 
    

    /*----------------------------------
    - RENDER
    ----------------------------------*/
    return <>

        <Analytics />

        <div id="layout" class={"admin row al-top sp-0"}>

            <header id="leftbar" class={"col sp-0" + (openMenu ? ' MenuOpen' : '')}>

                <div class="row al-left">
                    <Link title="Unique Domains" to="/" id="Logo">
                        unique<strong class="fg primary">.</strong>
                    </Link>
                </div>

                <nav class="col row-1 scrollable">

                    <ul class="col menu">
                        <li>
                            <Button icon="home" nav="exact" link="/app/godmode">
                                Home
                            </Button>
                        </li>
                        <li>
                            <Button icon="user-circle" nav link="/app/godmode/users">
                                Users
                            </Button>
                        </li>
                    </ul>

                    <strong>Blog</strong>
                    <ul class="col menu">
                        <li>
                            <Button icon="newspaper" nav="exact" link="/app/godmode/blog">
                                Articles
                            </Button>
                        </li>
                        <li>
                            <Button icon="plus-circle" nav link="/app/godmode/blog/create">
                                New Article
                            </Button>
                        </li>
                    </ul>
                </nav>

                <footer class="col pdv-1">
                    <div class="row sp-05 al-left">
                        <Button icon="brands/linkedin" shape="pill" type="secondary" size="s" />
                        <Button icon="brands/twitter" shape="pill" type="secondary" size="s" />
                        <Button icon="brands/facebook" shape="pill" type="secondary" size="s" />
                    </div>
                    <div class="txt-desc">
                        Crafted with ❤️ at Rouen 🇫🇷
                    </div>
                </footer>
            </header>

            <RouterComponent service={Router} loaderComponent={LoaderComponent} />
        </div>
    </>
}